import { createContext, useContext } from 'react'

export const EmblaCarouselContext = createContext<HTMLElement[]>([])

export function useCarouselItemsInView(ref: React.MutableRefObject<HTMLElement | null>) {
  const context = useContext(EmblaCarouselContext)

  return {
    isVisibleItem: Boolean(context.find(item => item === ref.current)),
  }
}
